import React from "react";
import './Aboutfacility.css';
// const facilities = 'https://res.cloudinary.com/dafd4nkgz/image/upload/v1742213741/image_1_tfdcs1.png';
const imggalley1 = 'https://res.cloudinary.com/dafd4nkgz/image/upload/v1742273131/19_y39yla.png';
const imggalley2 = 'https://res.cloudinary.com/dafd4nkgz/image/upload/v1742273148/20_la6z3a.png';
const imggalley3 = 'https://res.cloudinary.com/dafd4nkgz/image/upload/v1742273131/21_l2gne3.png';
// const imggalley4 = 'https://res.cloudinary.com/dafd4nkgz/image/upload/v1742273131/21_l2gne3.png';
// const imggalley5 = 'https://res.cloudinary.com/dafd4nkgz/image/upload/v1742273125/18_k5pwd4.png';
// import imggalley6 from '../../assets/facilities/img6.png';

const innovation1 = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742531772/innovation_luqjdg.png";
const innoimg1 = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742273125/18_k5pwd4.png";
const innoimg2 = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742273131/19_y39yla.png";
const innoimg3 = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742273148/20_la6z3a.png";
const inno22img1 = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742273131/21_l2gne3.png";
const inno31img = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742534125/makeinIndia_zcpvi4.png";
const inno32img = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742273198/22_vh4mey.png";
const inno322img = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742273127/23_jizt2j.png";
const innovation4 = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742273222/24_hjq3dm.png";


const Aboutfacilityours = () => {

    return (
        <>
            <div className="innovation1">
                <img src={innovation1} alt=""/>
            </div>

            <div className="innovation2">
                <div className="innovation21">
                    <div className="innoimg1">
                        <img src={innoimg1} alt="" />
                    </div>
                    <div className="innoimg2">
                        <img src={innoimg2} alt="" />
                    </div>
                    <div className="innoimg3">
                        <img src={innoimg3} alt="" />
                    </div>
                </div>
                <div className="innovation22">
                    <div className="inno22img1">
                        <img src={inno22img1} alt="" />
                    </div>
                    <div className="inno22text">
                        <p>At DASMESH, we're committed to setting new industry benchmarks through continuous research and innovation.</p>
                        <p><span>•</span> <span className="tbold">World Class infrastructure:</span> State-of-the-art facilities equipped with cutting-edge technology, mirroring global standards.</p>
                        <p><span>•</span> <span className="tbold">Expert engineering:</span> Dedicated team scrutinizing every production stage to ensure precision and quality.</p>
                        <p><span>•</span> <span className="tbold">Stringent Quality Control:</span> Raw materials and components sourced from vetted vendors meeting our rigorous standards.</p>
                        <p><span>•</span> <span className="tbold">Double-Check Inspection:</span> Raw materials inspected for uniformity before production to guarantee consistency.</p>
                        <p><span>•</span> <span className="tbold">Diverse Product Portfolio:</span> Comprehensive range of agricultural implements, including: • Combine Harvesters • Straw Reapers • Rotavators • Paddy Threshers • MB Plough • Disc Plough • Round Baler • Straw Baler • Chopper & Many more</p>
                        <p><span>•</span> <span className="tbold">Final Quality Assurance:</span> Rigorous testing of products and equipment according to latest quality measures.</p>
                    </div>
                </div>
            </div>

            <div className="innovation3">
                <div className="innovation31">
                    <div className="inno31img">
                        <img src={inno31img} alt="" />
                    </div>
                    <div className="inno31text">
                        <div className="inno3content">
                            <p>DASMESH: EMPOWERING INDIA'S AGRICULTURAL RENAISSANCE:</p>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;As a proud 'Make In India' success story, we champion indigenous procurement and manufacturing excellence. Our vision extends beyond national borders, aiming to showcase India's prowess on the global stage, earning international recognition and prosperity for the nation.</p>
                        </div>
                        <p>FUTURE FORWARD:-</p>
                        <ul className="inno3list">
                            <li>Diversify nationally and internationally, expanding our footprint</li>
                            <li>Introduce innovative equipment for effortless cultivation and enhanced crop productivit</li>
                            <li>Develop low-maintenance, wide-range products, merging utility and quality our long-term mission.</li>
                            <li>DASMESH as a global leader in agricultural innovation with unwavering commitment, we'll continue to script India's agricultural success story.</li>
                        </ul>
                    </div>
                </div>
                <div className="innovation32">
                    <div className="inno32img">
                        <img src={inno32img} alt="" />
                    </div>
                    <div className="inno32content">
                        <p>Our future focus will be based on the following strategies. Other than this, we are also contributing to the cause of</p>
                        <ul className="inno32list">
                            <li>Village cleanliness & sanitation drive</li>
                            <li>Tree plantation initiatives</li>
                            <li>Encouraging primary education in rural areas</li>
                            <li>Organizing health camps in rural areas</li>
                          <li>Taking active part in 'Swachh Bharat' campaign</li>
                        </ul>
                        <p className="inno32italic">We aspire to see a happy-healthy world around where the farmer gets support both from the Nature as well as a compassionate community.</p>
                        <div className="inno322img">
                            <img src={inno322img} alt="" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="innovation4">
                <img src={innovation4} alt="" />
            </div>

            {/* design */}
            {/* <div className="about-dasmesh-facitlies">
                <h3>INNOVATION & INFRASTRUCTURE</h3>
                <div className="row">
                    <div className="col-lg-6 col-md">
                        <div className="about-dasmesh-facilities-img"><img src={facilities} alt="facilities" /></div>
                    </div>
                    <div className="col-lg-6 col-md">
                        <div className="about-dasmesh-facilities-img-explaion">
                            In today’s fast-changing world, staying ahead in technology and processes is crucial to remain competitive in the international markets. Driven by this vision, DASMESH Management has embraced modern technology and taken a giant leap forward by establishing two state-of-the-art manufacturing plants.
                            One plant is dedicated to the production of advanced Combine Harvesters, including Self-Propelled Combine Harvesters, Track Combine Harvesters, and Tractor-Driven Combine Harvesters. The second plant focuses on manufacturing high-quality agricultural equipment such as Straw Reapers, Laser Land Levellers, Rotavators, and Roto Seed Drills.
                            These facilities embody the company's commitment to innovation and its dedication to delivering cutting-edge solutions to meet the evolving needs of the global agricultural sector.
                        </div>
                    </div>
                </div>
                <p>DASMESH Group has production facilities dedicated specially to cater to Domestic as well as Export markets. The production processes at each of the manufacturing stage involves minute details through advance planning integrated with most advanced and sophisticated machinery.</p>
                <div className="about-dasmesh-facilities-section-2">
                    <span>Our research activities are aimed at the following aspects:</span>
                    <p><b>CUTTING/SHEARING/BENDING </b>- Dasmesh Group employ the next generation technologies like Laser Cutting, Plasma cutting, Advance Robotics Welding, Hydraulic press, Shearing and Bending. We are equipped with accurate precision Laser cutting technology to deliver high tolerance and sturdy products.</p>
                    <p><b>POWDER COATING PAINT SHOP </b>- Dasmesh Group is equipped with in-house powder coating facilities. It is a modern technology that ensure superior protection against UVs, impact, and heat while imparting extreme durability and flexibility, as well as insulating properties. The modern equipment of our powder coat shop and the professional expertise of our employees allow us to carry out orders according to customer requirements and to meet the shortest possible deadlines.</p>
                </div>
            </div> */}

            <div className="about-dasmesh-facilities-gallery" style={{ display: 'none' }}>

                <div className="row">
                    <div className="col-lg-6 col-sm-4">
                        <div className="gallery-facilities"><img src={imggalley1} alt="img1"/></div>
                    </div>
                    <div className="col-lg-6 col-sm-4">
                        <div className="gallery-facilities"><img src={imggalley2} alt="img1" /></div>
                    </div>
                    <div className="col-lg-6 col-sm-4">
                        <div className="gallery-facilities"><img src={imggalley3} alt="img1"/></div>
                    </div>
                    {/* <div className="col-lg-6 col-sm-4">
                        <div className="gallery-facilities"><img src={imggalley4} alt="img1"/></div>
                    </div>
                    <div className="col-lg-6 col-sm-4">
                        <div className="gallery-facilities"><img src={imggalley5} alt="img1"/></div>
                    </div> */}
                    {/* <div className="col-lg-6 col-sm-4">
                        <div className="gallery-facilities"><img src={imggalley6} /></div>
                    </div> */}
                </div>

            </div>

        </>
    )
};

export default Aboutfacilityours
